var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelsiorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.11,
    height: 20,
    viewBox: "0 0 22.11 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Excelsior-Icon",
    transform: "translate(11.055 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Excelsior-Icon-2",
    "data-name": "Excelsior-Icon",
    d: "M22.11,4.357V0H0V20H11.073V15.933H5.544V12.349H9.43V7.941H5.544V4.357h7.464V7.941h0v4.409H16.9v3.584H11.437V20H22.11V7.941H18.284V4.357Z",
    transform: "translate(-11.055 -10)",
    fill: "#004987"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelsiorIcon);
export default __webpack_public_path__ + "static/media/Excelsior-Icon.ba1afa4cc39b72c5a293c6e392c940aa.svg";
export { ForwardRef as ReactComponent };